import AntModal from './AntModal'

export default AntModal
